<template>
  <Nav />
  <div class="not-found">
    <h1>404 - Página não encontrada</h1>
    <p>A página eu você tentou acessar não existe.</p>
    <p>Redirecionando...</p>
    <!-- <router-link to="/">Go to Home</router-link> -->
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";

export default {
  name: "NotFound",
  components: {
    Nav,
  },
  created() {
    setTimeout(() => {
      this.$router.push("/");
    }, 3000);
  },
};
</script>

<style>
.not-found {
  text-align: center;
  margin-top: 50px;
}
</style>
